import { IPlatformApi } from '@lved/shared-core';
import { TheiaApi } from './implementations/theia.js';
export { TheiaApi } from './implementations/theia.js';
export { AppwriteGitHubService } from './github/AppwriteGitHubService.js';
export { GitHubAuthService } from './github/GitHubAuthService.js';
export { GitHubFileSystem } from './github/GitHubFileSystem.js';
export { GitHubService } from './github/GitHubService.js';
export { RepositoryArchiveSnapshot } from './github/RepositoryArchiveSnapshot.js';
export { normalizeRepoPath } from './github/helpers.js';
export type { ParsedRepo } from './github/GitHubService.js';
export type * from './github/githubTypes.js';
export type { GitHubFetchOptions } from './types/githubFetchOptions.js';

const isTheiaEnvironment = (): boolean => {
    if (typeof window !== 'undefined') {
        const theiaWindow = window as Window & {
            electronTheiaCore?: unknown;
            electronTheiaFilesystem?: unknown;
        };
        if (theiaWindow.electronTheiaCore || theiaWindow.electronTheiaFilesystem) return true;
    }

    return typeof document !== 'undefined' && document.getElementById('theia-app-shell') !== null;
};

const resolvePlatformApi = (): IPlatformApi => {
    if (window._platformApi) {
        return window._platformApi;
    }

    if (isTheiaEnvironment()) {
        window._platformApi = new TheiaApi();
        return window._platformApi;
    }

    throw new Error('Could not detect environment (Theia) to determine what implementation of platformApi to use.');
};

const platformApiHandler: ProxyHandler<IPlatformApi> = {
    get(_target, prop, _receiver) {
        const api = resolvePlatformApi();
        const value = (api as unknown as Record<PropertyKey, unknown>)[prop];
        return typeof value === 'function' ? (value as (...args: never[]) => unknown).bind(api) : value;
    }
};

/** Resolves on first property access so Theia can install `window._platformApi` before any call site runs. */
export const platformApi: IPlatformApi = new Proxy({} as IPlatformApi, platformApiHandler);

export default platformApi;
